module.exports = __webpack_public_path__ + "img/step-3-img@2x.png";